// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type PhoneNumber } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useDeletePhoneNumber(): (
  phoneNumberId: string
) => Promise<PhoneNumber> {
  const getAPI = useGetApi();
  return useCallback(
    async (phoneNumberId) =>
      (await getAPI()).phonenumbers.deletePhoneNumber({ phoneNumberId }),
    [getAPI]
  );
}
